<ng-container>
  <div (click)="togglePopupMenu($event,VCDropdown,position)">
    <ng-container *ngIf="!hostElement">
      <div [ngClass]="{'md-menu-item': !disabled}">
        <div class="grid-1-auto">
          <div>{{label}}</div>
          <i *ngIf="!disabled" class="md-menu-item-sort far"
             [ngClass]="{'fa-chevron-down': position.indexOf('under') > -1, 'fa-chevron-up': position.indexOf('above') > -1}"></i>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="hostElement">
      <ng-container *ngTemplateOutlet="hostElement"></ng-container>
    </ng-container>
  </div>
  <ng-template #test>
    <exg-popup #VCDropdown [closeAlways]="false" width="auto" style="z-index: 1200;">
	    <div class="content md-menu"
	         appExgAdaptiveHeight
	         [adaptiveHeightOffset]="adaptiveHeightOffset"
	         [adaptiveHeightActive]="adaptiveHeightActive"
	         [hasOffsetTop]="false"
	    >
		    <ng-container *ngIf="!contentElement">
			    <div (click)="change.emit({index: i,value: item}); VCDropdown.close();"
			         *ngFor="let item of list; index as i"
			         class="md-menu-item {{elementclass}}">{{(listdisplay) ? item[listdisplay] + '&nbsp;' : item}}</div>
		    </ng-container>
		    <ng-container *ngIf="contentElement">
			    <ng-container *ngTemplateOutlet="contentElement; context: {$implicit: VCDropdown}"></ng-container>
		    </ng-container>
	    </div>
    </exg-popup>
  </ng-template>
  <ng-container *ngIf="!added">
    <ng-container *ngTemplateOutlet="test"></ng-container>
  </ng-container>
</ng-container>
